// Keep the scrollbar track below the sticky 32px column header.
export const offerTableScrollSx = {
  flex: 1,
  minHeight: 0,
  overflowX: 'scroll',
  overflowY: 'auto',
  '&::-webkit-scrollbar': { width: 12, height: 12, backgroundColor: 'primary.main' },
  '&::-webkit-scrollbar-track': { backgroundColor: 'background.paper' },
  '&::-webkit-scrollbar-track:vertical': { marginTop: '32px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: 'text.secondary', borderRadius: 6 },
  '@media print': { overflow: 'visible' },
} as const;
